import React from 'react';

import useFeatureToggles from '@/common/hooks/feature-toggles';
import { SignInArcGisPage } from '@/features/arcgis-auth/SignInArcGisPage';

import { CenteredLoadingPage } from './CenteredLoadingPage';

export const AuthenticatingArcGis = () => {
  const isNewAuthVersionEnabled = useFeatureToggles().isNewAuthVersionEnabled();
  return (
    <>
      {isNewAuthVersionEnabled ? (
        <SignInArcGisPage />
      ) : (
        <CenteredLoadingPage text="Authenticating…" />
      )}
    </>
  );
};
